// Mirrors Core MINIMUM_PRODUCT_BASE_PRICE_AMOUNT, applied in every currency.
export const MINIMUM_PRODUCT_PRICE_AMOUNT = '10.000'
